import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AppBackReason =
  | "MENU_PLAYBACK"
  | "MENU_GPS_TRACKING"
  | "MENU_REPORT"
  | "ERR_NO_INTERNET"
  | "BC_ERR_AUTHENTICATION"
  | "DEVICE_DISCONNECT";

interface IState {
  removePlayer: boolean;
  reason?: AppBackReason;
}

let initialState: IState = {
  removePlayer: false,
  reason: undefined,
};

const slice = createSlice({
  name: "liveview",
  initialState,
  reducers: {
    finishLiveview: (
      state,
      { payload }: PayloadAction<AppBackReason | undefined>
    ) => {
      console.log("CloudNative", "finishLiveview", payload);
      if (!state.removePlayer) {
        state.reason = payload;
        state.removePlayer = true;
      }
    },
    startLiveView: (state) => {
      state.removePlayer = false;
    },
  },
});

export const { finishLiveview, startLiveView } = slice.actions;
export const LIVEVIEW = slice.name;
export default slice.reducer;
